(() => {
  let pendingCheckout = null;

  const closeDialog = (dialog) => {
    if (dialog?.open) dialog.close();
  };

  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest('.cart__checkout-button[data-hn-b2g1-state="ready"]');

      if (checkout) {
        if (checkout.dataset.hnB2g1Bypass === 'true') {
          delete checkout.dataset.hnB2g1Bypass;
          return;
        }

        const dialog = document.getElementById(checkout.dataset.hnB2g1Dialog);
        if (!dialog) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        pendingCheckout = checkout;
        dialog.showModal();
        return;
      }

      const close = event.target.closest('[data-hn-b2g1-close]');
      if (close) {
        closeDialog(close.closest('dialog'));
        pendingCheckout = null;
        return;
      }

      const continueButton = event.target.closest('[data-hn-b2g1-continue]');
      if (continueButton && pendingCheckout) {
        const button = pendingCheckout;
        pendingCheckout = null;
        closeDialog(continueButton.closest('dialog'));
        button.dataset.hnB2g1Bypass = 'true';
        button.click();
        return;
      }

      if (event.target.matches('.hn-b2g1-dialog')) {
        closeDialog(event.target);
        pendingCheckout = null;
      }
    },
    true
  );
})();
